import { createSlice } from "@reduxjs/toolkit";
import { sagaActions } from "../sagas/sagaActions";

const initialState = {
  items: [],
};

export const spicesSlice = createSlice({
  name: "spices",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(sagaActions.SPICES_LOAD, (state, action) => {
      state.items = action.data.sort((a, b) => b.sale - a.sale);
    });
  },
});

export default spicesSlice.reducer;
